import React from 'react';
import { LoanDetailsCard } from './LoanDetailsCard';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { useUpdateOrderTimberHook } from '../../../../API/order/useUpdateOrderHook';

interface ILoanDetailsContainerProps {}

export const LoanDetailsContainer: React.FC<ILoanDetailsContainerProps> = () => {
  const { data: orderDetails } = useSelectCurrentOrder();
  const { action: doUpdateAsync, status: doUpdateStatus } = useUpdateOrderTimberHook();
  const onUpdate = async (values: any) =>
    await doUpdateAsync(orderDetails, {
      loanId: values.loan_number,
      loanAmount: values.loan_amount,
      purchasePrice: values.purchase_price,
    });

  return (
    <LoanDetailsCard
      loanAmount={orderDetails.transaction.loan_amount}
      loanNumber={orderDetails.transaction.loan_number}
      purchasePrice={orderDetails.transaction.purchase_price}
      transactionType={orderDetails.transaction.transaction_category}
      onUpdate={onUpdate}
      updateStatus={doUpdateStatus.status}
    />
  );
};
